import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import SummaryCard from '../../components/Cards/SummaryCard';
import DonutChart from '../../components/Charts/DonutChart';
import usePurchaseDashboard from '../../hooks/dashboard/usePurchaseDashboard';

const PurchasesDashboard: React.FC = () => {
  const { stats, fetchStats } = usePurchaseDashboard();

  useEffect(() => {
    fetchStats();
  }, []);

  // 🔹 Orden correcto de estados según backend (Pendiente, Finalizada = SETTLED, Anulada)
  const orderedStatus = ['Pendiente', 'Finalizada', 'Anulada'];

  const statusLabels = orderedStatus;
  const statusSeries = orderedStatus.map((key) => stats.purchasesByStatus[key] || 0);
  const statusColors = [
    '#F59E0B', // Pendiente → amarillo
    '#3C50E0', // Finalizada (SETTLED) → azul
    '#EF4444', // Anulada → rojo
  ];

  // 🔹 Otros gráficos
  const docTypeLabels = Object.keys(stats.purchasesByDocumentType || {});
  const docTypeSeries = Object.values(stats.purchasesByDocumentType || {});
  const supplierLabels = Object.keys(stats.purchasesBySupplier || {});
  const supplierSeries = Object.values(stats.purchasesBySupplier || {});
  const branchLabels = Object.keys(stats.purchasesByBranch || {});
  const branchSeries = Object.values(stats.purchasesByBranch || {});

  // Paletas de colores
  const docTypeColors = ['#8FD0EF', '#0FADCF', '#6366F1', '#FBBF24'];
  const supplierColors = ['#10B981', '#F59E0B', '#F97316', '#3B82F6'];
  const branchColors = ['#14B8A6', '#6366F1', '#F59E0B', '#F43F5E'];

  return (
    <DefaultLayout>
      {/* ✅ Tarjetas resumen */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
        <SummaryCard
          title="Total de Compras"
          value={stats.totalPurchases.toString()}
          rate=""
          iconName="purchase"
        />
        <SummaryCard
          title="Compras Pendientes"
          value={(stats.purchasesByStatus['Pendiente'] || 0).toString()}
          rate=""
          iconName="clock"
        />
        <SummaryCard
          title="Compras Finalizadas"
          value={(stats.purchasesByStatus['Finalizada'] || 0).toString()}
          rate=""
          iconName="check-circle"
        />
        <SummaryCard
          title="Compras Anuladas"
          value={(stats.purchasesByStatus['Anulada'] || 0).toString()}
          rate=""
          iconName="x-circle"
        />
      </div>

      {/* ✅ Gráficos Donut */}
      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Compras por tipo de documento"
            labels={docTypeLabels}
            series={docTypeSeries}
            colors={docTypeColors.slice(0, docTypeLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Compras por proveedor"
            labels={supplierLabels}
            series={supplierSeries}
            colors={supplierColors.slice(0, supplierLabels.length)}
          />
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Compras por sucursal"
            labels={branchLabels}
            series={branchSeries}
            colors={branchColors.slice(0, branchLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Compras por estado"
            labels={statusLabels}
            series={statusSeries}
            colors={statusColors.slice(0, statusLabels.length)}
          />
        </div>
      </div>

    </DefaultLayout>
  );
};

export default PurchasesDashboard;
